import { takeLatest } from 'redux-saga/effects';
import {
  getSalaryAdjustmentListSuccess, getSalaryAdjustmentListFail,
  getSalaryAdjustmentDetailsSuccess, getSalaryAdjustmentDetailsFail
} from './salaryAdjustmentState';
import createCrudService from '../../services/crudservice';
import { doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess  } from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/finance/salary-adjustments');
const redirectData = {route:'console/salary-adjustments', mode: 'list', recordId:0 };
const modelName = 'Salary Adjustment';
const modelId = 'sdj_id';

function* getSalaryAdjustmentList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getSalaryAdjustmentListSuccess, 
		getSalaryAdjustmentListFail,
		null, null, LOADING_MSG);
}

function* getSalaryAdjustmentDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getSalaryAdjustmentDetailsSuccess, 
		getSalaryAdjustmentDetailsFail,
		null, null, LOADING_MSG);		
}

function* doSalaryAdjustmentCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getSalaryAdjustmentDetailsSuccess, 
		getSalaryAdjustmentDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: 'reload'}, SAVING_MSG);
}

function* doSalaryAdjustmentUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getSalaryAdjustmentDetailsSuccess, 
		getSalaryAdjustmentDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: 'reload'}, UPDATING_MSG);	
}

function* doSalaryAdjustmentDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getSalaryAdjustmentDetailsSuccess, 
		getSalaryAdjustmentDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* salaryAdjustmentSaga() {
  yield takeLatest('salaryAdjustment/getSalaryAdjustmentList', getSalaryAdjustmentList);
  yield takeLatest('salaryAdjustment/getSalaryAdjustmentDetails', getSalaryAdjustmentDetails);
  yield takeLatest('salaryAdjustment/doSalaryAdjustmentCreate', doSalaryAdjustmentCreate);
  yield takeLatest('salaryAdjustment/doSalaryAdjustmentUpdate', doSalaryAdjustmentUpdate);
  yield takeLatest('salaryAdjustment/doSalaryAdjustmentDelete', doSalaryAdjustmentDelete);  
}

export default salaryAdjustmentSaga;
